import { render, staticRenderFns } from "./select-states.component.vue?vue&type=template&id=39c3fd19&"
import script from "./select-states.component.vue?vue&type=script&lang=ts&"
export * from "./select-states.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports